import { E_AlarmLevel, E_AlarmLevel2 } from "@/api/enums"
import { E_AlarmLevelStr } from "@/api/moudules/threshold.types"

export function replaceTo(vm: Vue, s: string) {
    if (!s) {
        return s
    }
    let to = vm.$t('common.to') as string
    return s.replace('至', ` ${to} `)
}

const MonthCycle_REGEX = /(.*)年第(.*)周/

export function replaceMonthCycle(vm: Vue, s: string) {
    if (!s) {
        return s
    }
    const match = s.match(MonthCycle_REGEX)
    if (match) {
        const year = match[1]
        const week = match[2]
        return vm.$t('weeklyReport.monthCycleTemplate', {
            year,
            week
        }) as string
    }
    return s
}

const STR = "%s年第%s周";
const REPROTNAME0 = "%s在线监测周报";
const REPROTNAME = "%s在线监测周报-%s";
const COALARMTITLE = "本次报告(%s)，%s公司检测设备%s台，其中%s台设备正常运行，%s台设备C级报警，%s台设备D级报警，%s台设备离线报警";
const CODIAGNOSISTITLE = "全厂设备监测，其中C级，D级报警设备的缺陷故障诊断比例如下图:";
const AREAALARMTITLE = "%s区域设备%s台，其中%s台设备正常运行，%s台设备C级报警，%s台设备D级报警，%s台设备离线报警";
const EQUIPMENTTITLE = "%s设备详细体检报告";
const EQUIPMENTDIAGNOSIS = "振动分析%s、峭度分析%s、波峰因素%s";

function templateToRegex(s: string) {
    let pattern = s.replaceAll('%s', '(.*)')
    return new RegExp(pattern)
}

function buildReplaceFunc(temp: string, i18n_key: string) {
    const RE = templateToRegex(temp)
    return function (vm: Vue, s: string) {
        if (!s) {
            return s
        }
        const match = s.match(RE)
        if (match) {
            return vm.$t(i18n_key, match)
        }
        return s
    }
}

// $t('weeklyReport.REPROTNAME0_Template')
// $t('weeklyReport.REPROTNAME_Template')
// $t('weeklyReport.COALARMTITLE_Template')
// $t('weeklyReport.CODIAGNOSISTITLE_Template')
// $t('weeklyReport.AREAALARMTITLE_Template')
// $t('weeklyReport.EQUIPMENTTITLE_Template')
// $t('weeklyReport.EQUIPMENTDIAGNOSIS_Template')
export const WeeklyReplacers = {
    REPROTNAME0: buildReplaceFunc(REPROTNAME0, 'weeklyReport.REPROTNAME0_Template'),
    REPROTNAME: buildReplaceFunc(REPROTNAME, 'weeklyReport.REPROTNAME_Template'),
    COALARMTITLE: buildReplaceFunc(COALARMTITLE, 'weeklyReport.COALARMTITLE_Template'),
    CODIAGNOSISTITLE: buildReplaceFunc(CODIAGNOSISTITLE, 'weeklyReport.CODIAGNOSISTITLE_Template'),
    AREAALARMTITLE: buildReplaceFunc(AREAALARMTITLE, 'weeklyReport.AREAALARMTITLE_Template'),
    EQUIPMENTTITLE: buildReplaceFunc(EQUIPMENTTITLE, 'weeklyReport.EQUIPMENTTITLE_Template'),
    EQUIPMENTDIAGNOSIS: buildReplaceFunc(EQUIPMENTDIAGNOSIS, 'weeklyReport.EQUIPMENTDIAGNOSIS_Template'),
}

export const RE_Diagnosis = /振动分析.*、峭度分析.*、波峰因素.*、温度分析.*/


const alarmLevelTable = {
    [E_AlarmLevelStr.A级]: E_AlarmLevel2.A,
    [E_AlarmLevelStr.B级]: E_AlarmLevel2.B,
    [E_AlarmLevelStr.C级]: E_AlarmLevel2.C,
    [E_AlarmLevelStr.D级]: E_AlarmLevel2.D,
}

export function toAlaramLevel(e: E_AlarmLevelStr) {
    return alarmLevelTable[e]
}
